import Page from '../components/Page';
import AuditPanel from '../components/AuditPanel';
import { useT } from '../i18n';

// Issue #550: Auditoria LGPD como pagina propria no grupo "Gestao" —
// antes tab do AdminPanel (issue #546, apenas super_user). Agora exposta
// aos tenants: o backend ja e org-scoped e seguro (query sempre filtra
// organization_id; AUDIT_ROLES = super_user/parceiro/admin/owner/auditor,
// validada na org resolvida). O guard por role fica no App.tsx.
function Audit() {
  const t = useT();
  return (
    <Page title={t('audit.title')} subtitle={t('audit.subtitle')}>
      <AuditPanel />
    </Page>
  );
}

export default Audit;
